<script>    
    import { fade,slide } from 'svelte/transition';
    import dayjs from 'dayjs';
    import SveltyPicker from 'svelty-picker';
    
    import PasswordStrength from "svelte-password-strength-bar";
    import { bookOneCourseIndividual } from '/public/services/courses.js';
    import { checkAccountExists } from '/public/services/User.js';

    export let obj;
    export let course;
    export let provinces;

    let types = null;
    let showProvince = true;   
    let showEditDate = false;
    let emailOk = false;
    let dupEmail = false;

    if (obj.is_student != null) {
        if (obj.is_student === true) {
            setIsStudent();
        } else {
            setIsNotStudent();
        }
    }

    if (obj.province_id != null) {
        showProvince = false;
    }

    function doSubmit(e) {
        e.preventDefault();

        bookOneCourseIndividual(course.id,obj).then(res => {
            if (res.success) {
                window.location = res.data.url;
            }
        });
    }

    function setIsStudent() {        
        obj.is_student = true;

        types = course.types.filter(function(t) {
            return t.is_student === true;
        });
    }
    
    function setIsNotStudent() {
        obj.is_student = false;

        types = course.types.filter(function(t) {
            return t.is_student === false;
        });
    }

    function onDobChange(evt) {
        showEditDate = false;
    }

    function setType(ty) {
        obj.courseType = ty;
        obj.course_type_id = ty.id;
    }

    function selectProvince(pro) {
        obj.province_id = pro.id;
        obj.province_name = pro.title;
        showProvince = false;
    }

    function checkEmail() {
        emailOk = false;
        dupEmail = false;

        checkAccountExists({ email: obj.email}).then(res => {
            if (res.success) {
                dupEmail = res.data.check;

                if (dupEmail === false) {
                    emailOk = true;
                }
            }
        });
    }

</script>

<form class='form' on:submit={doSubmit}>
    <fieldset>
        <legend>
            Are you a Student?
        </legend>
        <div class='row mb-3'>
            <div class='col-sm-12'>
                <div class='list-group'>
                    <div
                        class='list-group-item js-button'
                        on:click={() => setIsStudent()}
                        on:keypress={() => setIsStudent()}
                        class:active='{obj.is_student === true}'
                        role='button'
                        tabindex='0'
                    >
                        {#if obj.is_student === true}

                            <span class='fas fa-check-circle text-success'></span>

                        {/if}

                        Yes, I am a Student and can provide a <span class='fw-bold'>valid photo ID</span> to an instructor on my course 

                    </div>
                    <div
                        class='list-group-item js-button'
                        on:click={() => setIsNotStudent()}
                        on:keypress={() => setIsNotStudent()}
                        class:active='{obj.is_student === false}'
                        role='button'
                        tabindex='0'
                    >
                        {#if obj.is_student === false}

                            <span class='fas fa-times-circle text-success'></span>

                        {/if}

                        No, I am not a Student

                    </div>
                </div>                 
            </div>
        </div>
    </fieldset>

    {#if obj.is_student != null}

        <fieldset in:fade>
            <legend>
                What type of course do you need?
            </legend>
            <div class='row mb-3'>
                <div class='col-sm-12'>

                    {#if types.length == 0}

                        <div class='alert alert-info clearfix mb-3'>
                            <h4 class='float-start me-3'>
                                <span class='fas fa-info-circle'></span>
                            </h4>
                            Sorry, we don't have any applicable course types available in this course.
                        </div>

                    {:else}

                        <div class='list-group'>

                            {#each types as ty}

                                <div
                                    class='list-group-item js-button clearfix'
                                    on:click={() => setType(ty)}
                                    on:keypress={() => setType(ty)}
                                    class:active='{obj.course_type_id == ty.id}'
                                    role='button'
                                    tabindex='0'
                                >
                                    <span class='float-end ms-2'>
                                        ${ ty.price }
                                    </span>

                                    {#if obj.course_type_id == ty.id}

                                        <span class='fas fa-check-circle text-success me-3' in:fade out:fade></span>

                                    {/if}

                                    { ty.title }
                                </div>

                            {/each}

                        </div>

                    {/if}

                </div>
            </div>
        </fieldset>

    {/if}

    {#if obj.course_type_id}

        <section in:fade>
            <fieldset>
                <legend>
                    What are your details?
                </legend>
                <p class='form-text text-muted'>
                    <span class='fas fa-info-circle'></span> We need your details so that we can create an account for you.
                </p>

                {#if dupEmail === true}

                    <div class='alert alert-danger clearfix mb-3' in:slide out:slide>
                        <a href='/login' class='btn btn-outline-primary float-end ms-2'>
                            <span class='fas fa-sign-in-alt'></span> Login
                        </a>
                        <h4 class='float-start me-3'>
                            <span class='fas fa-info-circle'></span>
                        </h4>
                        You already have an account with this email address, please login to create your booking.
                    </div>

                {/if}

                <div class='row mb-3'>
                    <label class='col-sm-3 col-form-label' for='email'>
                        Email  <span class='fas fa-asterisk text-danger'></span>
                    </label>
                    <div class='col-sm-9'>
                        <div class='input-group'>
                            <div class='input-group-text'>
                                <span class='fas fa-envelope'></span>
                            </div>
                            <input 
                                type='email'
                                class='form-control'
                                bind:value={obj.email}
                                required
                                placeholder="What is your email?"
                                class:is-invalid='{obj.email == null}'
                                on:blur={checkEmail}
                            />
                        </div>
                    </div>
                </div>
                <div class='row mb-3'>
                    <label class='col-sm-3 col-form-label' for='first'>
                        First Name <span class='fas fa-asterisk text-danger'></span>
                    </label>
                    <div class='col-sm-9'>
                        <input 
                            type='text'
                            class='form-control'
                            bind:value={obj.first_name}
                            required
                            placeholder="What is your first name?"
                            class:is-invalid='{obj.first_name == null}'
                        />
                    </div>
                </div>
                <div class='row mb-3'>
                    <label class='col-sm-3 col-form-label' for='last'>
                        Last Name <span class='fas fa-asterisk text-danger'></span>
                    </label>
                    <div class='col-sm-9'>
                        <input 
                            type='text'
                            class='form-control'
                            bind:value={obj.last_name}
                            required
                            placeholder="What is your last name?"
                            class:is-invalid='{obj.last_name == null}'
                        />
                    </div>
                </div>       
                
                {#if emailOk === true}

                    <section in:fade>
                        <div class="row mb-3">
                            <label class="col-sm-3 col-form-label" for="password">
                                Password
                            </label>
                            <div class="col-sm-9">
                                <input id="password" type="password" bind:value={obj.password} class="form-control" placeholder="Enter password - min 8 chars" required/>
                            </div>
                        </div>
                        <div class="row mb-3">
                            <label class="col-sm-3 col-form-label" for="password_confirmation">
                                Password Confirmation
                            </label>
                            <div class="col-sm-9">
                                <input id="password_confirmation" type="password" bind:value={obj.password_confirmation} class="form-control" placeholder="And again" required/>
                            </div>
                        </div>

                        {#if obj.password != null}

                            <div class='row mb-3' in:slide>
                                <label class='col-form-label col-sm-3' for='strength'>
                                    Password Strength
                                </label>
                                <div class='col-sm-9'>
                        
                                    <PasswordStrength password={obj.password}/>
                        
                                </div>
                            </div>

                        {/if}
                        <div class='row mb-3'>
                            <label class='col-sm-3 col-form-label' for='secondary_email'>
                                Secondary Email
                            </label>
                            <div class='col-sm-9'>
                                <div class='input-group'>
                                    <div class='input-group-text'>
                                        <span class='fas fa-envelope'></span>
                                    </div>
                                    <input 
                                        type='email'
                                        class='form-control'
                                        bind:value={obj.secondary_email}                            
                                        placeholder="Optional secondary email"                            
                                    />
                                </div>
                            </div>
                        </div>
                        <div class='row mb-3'>
                            <label class='col-sm-3 col-form-label' for='phone'>
                                Phone
                            </label>
                            <div class='col-sm-9'>
                                <div class='input-group'>
                                    <div class='input-group-text'>
                                        <span class='fas fa-phone'></span>
                                    </div>
                                    <input 
                                        type='text'
                                        class='form-control'
                                        bind:value={obj.phone}                            
                                        placeholder="Optional phone number"                            
                                    />
                                </div>
                            </div>
                        </div>
                        <div class='row mb-3'>
                            <label class='col-sm-3 col-form-label' for='mobile'>
                                Mobile
                            </label>
                            <div class='col-sm-9'>
                                <div class='input-group'>
                                    <div class='input-group-text'>
                                        <span class='fas fa-mobile'></span>
                                    </div>
                                    <input 
                                        type='text'
                                        class='form-control'
                                        bind:value={obj.mobile}                            
                                        placeholder="Optional mobile number"                            
                                    />
                                </div>
                            </div>
                        </div>
                        <div class='row mb-3'>
                            <label class='col-sm-3 col-form-label' for='nsn'>
                                NSN
                            </label>
                            <div class='col-sm-9'>                    
                                <input 
                                    type='text'
                                    class='form-control'
                                    bind:value={obj.nsn}                            
                                    placeholder="Optional NSN number"                            
                                />      
                                <p class='form-text'>
                                    Required for NZQA reporting and auditing if you need a credit for your course.<br/>
                                    Your National Student Number (NSN) is required for us to lodge credits to your record of learning. If you are unsure what your number is please call NZQA: 0800 697 296 to request your NSN. 
                                </p>              
                            </div>
                        </div>
                        <div class='row mb-3'>
                            <label class='col-sm-3 col-form-label' for='dob'>
                                Date of Birth <span class='fas fa-asterisk text-danger'></span>
                            </label>
                            <div class='col-sm-9'>       
                                <p class='form-text'>
                                    Required for NZQA reporting and auditing
                                </p>             
                                
                                {#if showEditDate === false}

                                    <div class='clearfix'>
            
                                        <button type='button' class='btn btn-outline-primary btn-sm float-end ms-2' on:click={() => showEditDate = true}>
                                            <span class='fas fa-edit'></span> Edit DOB
                                        </button>
                
                                        {#if obj.dob }
                
                                            <span class='fas fa-calendar-day ms-2'></span> { dayjs(obj.dob).format('DD-MM-YYYY')}
                
                                        {:else}
                
                                            <span class='text-warning'>
                                                <span class='fas fa-exclamation-circle'></span> DOB has not been set
                                            </span>
                
                                        {/if}

                                    </div>
            
                                {:else}
            
                                    <section in:slide out:slide>
                                        <p class='text-end mb-3'>                            
                                            <button type='button' class='btn btn-outline-secondary' on:click={() => showEditDate = false}>
                                                <span class='fas fa-times-circle'></span> Cancel
                                            </button>
                                        </p>    
                                        <div>

                                            <SveltyPicker 
                                                inputClasses="form-control" 
                                                format="yyyy-mm-dd" 
                                                bind:value={obj.dob}
                                                pickerOnly=true
                                                on:change={onDobChange}
                                                endDate={dayjs().toDate}
                                                startView={0} 
                                                autocommit={false}
                                            />

                                        </div>
                                    </section>
            
                                {/if}
            
                            </div>
                        </div>
                    </section>

                {/if}

            </fieldset>
        </section>

    {/if}

    {#if obj.dob != null}

        <section in:fade>
            <fieldset>
                <legend>
                    What is your address? 
                </legend>
                <div class='row mb-3'>
                    <label class='col-sm-3 col-form-label' for='address1'>
                        Address 1 <span class='fas fa-asterisk text-danger'></span>
                    </label>
                    <div class='col-sm-9'>                    
                        <input 
                            type='text'
                            class='form-control'
                            bind:value={obj.address1}                            
                            placeholder="Address One"    
                            required
                            class:is-invalid='{obj.address1 == null}'                        
                        />                    
                    </div>
                </div>
                <div class='row mb-3'>
                    <label class='col-sm-3 col-form-label' for='address2'>
                        Address 2
                    </label>
                    <div class='col-sm-9'>                    
                        <input 
                            type='text'
                            class='form-control'
                            bind:value={obj.address2}                            
                            placeholder="Optional Address Two"                            
                        />                    
                    </div>
                </div>
                <div class='row mb-3'>
                    <label class='col-sm-3 col-form-label' for='suburb'>
                        Suburb
                    </label>
                    <div class='col-sm-9'>                    
                        <input 
                            type='text'
                            class='form-control'
                            bind:value={obj.suburb}                            
                            placeholder="Optional Suburb"                            
                        />                    
                    </div>
                </div>
                <div class='row mb-3'>
                    <label class='col-sm-3 col-form-label' for='city'>
                        City <span class='fas fa-asterisk text-danger'></span>
                    </label>
                    <div class='col-sm-9'>                    
                        <input 
                            type='text'
                            class='form-control'
                            bind:value={obj.city}                            
                            placeholder="City"                            
                            required
                            class:is-invalid='{obj.city == null}'
                        />                    
                    </div>
                </div>
                <div class='row mb-3'>
                    <label class='col-sm-3 col-form-label' for='postcode'>
                        Postcode <span class='fas fa-asterisk text-danger'></span>
                    </label>
                    <div class='col-sm-9'>                    
                        <input 
                            type='text'
                            class='form-control'
                            bind:value={obj.postcode}                            
                            placeholder="Postcode"                            
                            required
                            class:is-invalid='{obj.postcode == null}'
                        />                    
                    </div>
                </div>
                <div class='row mb-3'>
                    <label class='col-sm-3 col-form-label' for='postcode'>
                        Province <span class='fas fa-asterisk text-danger'></span>
                    </label>
                    <div class='col-sm-9'>    
                        {#if showProvince === false}
                            <div class='clearfix'>
    
                                <button type='button' class='btn btn-outline-primary btn-sm float-end ms-2' on:click={() => showProvince = true}>
                                    <span class='fas fa-edit'></span> Edit Province
                                </button>
        
                                <span class='fas fa-map-marker-alt'></span> { obj.province_name }

                            </div>
                        
                        {:else}
                            
                            <div class='list-group' in:fade out:fade>
    
                                {#if obj.province_id != null}
    
                                    <div class='list-group-item text-end'>
                                        <button type='button' class='btn btn-outline-secondary' on:click={() => showProvince = false}>
                                            <span class='fas fa-times-circle'></span> Cancel
                                        </button>
                                    </div>
    
                                {/if}
    
                                {#each provinces as po}
    
                                    <div
                                        class='list-group-item js-button'
                                        on:click={() => selectProvince(po)}
                                        on:keypress={() => selectProvince(po)}
                                        class:active='{obj.province_id == po.id}'
                                        role='button'
                                        tabindex='0'
                                    >
    
                                        {#if obj.province_id == po.id}
                                            
                                            <span class='fas fa-check-circle me-2' in:fade out:fade></span>
    
                                        {/if}
    
                                        { po.title }
    
                                    </div>
    
                                {/each}
    
                            </div>   
                            
                        {/if}
    
                    </div>
                </div>
                <div class='row mb-3'>
                    <label class='col-sm-3 col-form-label' for='country'>
                        Country <span class='fas fa-asterisk text-danger'></span>
                    </label>
                    <div class='col-sm-9'>                    
                        <input 
                            type='text'
                            class='form-control'
                            bind:value={obj.country}                            
                            placeholder="Optional Country"    
                            required
                            class:is-invalid='{obj.country == null}'                        
                        />                    
                    </div>
                </div>
            </fieldset>
            <fieldset>
                <legend>
                    Payment
                </legend>
                <div class='row mb-3'>
                    <div class='col-sm-9 offset-sm-3'>
                        <div class='d-grid'>
                            <button type='submit' class='btn btn-outline-primary'>
                                <span class='fas fa-save'></span> Save
                            </button>
                        </div>
                        <div class='mt-3 mb-3'>
                            <p class='form-text'>
                                You will be redirected to Payment Express to complete your booking. 
                            </p>
                            <div>
                                <img src='/app/images/pxpay/paymentexpress.png' class='img-responsive pe-logo' alt="Payment Express"/>
                            </div>
                        </div>
                    </div>
                </div>
            </fieldset>
        </section>

    {/if}
</form>

<style>
    .pe-logo {
        background: #f73f23; 
        padding: 5px;
    }
</style>